import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./myiq.css";
import axiosInstance from "../axiosConfig";

function MyIQ() {
  const [pendingCount, setPendingCount] = useState(0);
  const [userProfile, setUserProfile] = useState(null);
  const [memberProfile, setMemberProfile] = useState(null);
  const [username, setUsername] = useState("");

  // Fetch username from the auth/current-user API
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axiosInstance.get("/auth/current-user/");
        setUsername(response.data.username);
      } catch (error) {
        console.error("Error fetching user data", error);
      }
    };

    fetchUserData();
  }, []);

  // Once we have username, fetch pending requests and profile
  useEffect(() => {
    const checkPendingRequests = async () => {
      try {
        const response = await axiosInstance.get(
          "/myclub/requests/pending-notification/"
        );
        setPendingCount(response.data.has_pending ? 1 : 0);
      } catch (error) {
        console.error("Error checking pending requests", error);
      }
    };

    const fetchUserProfile = async () => {
      try {
        const response = await axiosInstance.get(
          `/memberprofile/${username}/`
        );
        setUserProfile(response.data);
      } catch (error) {
        console.error("Error fetching profile", error);
      }
    };

    // In MyIQ.js, update the member portal check:
    const checkMemberPortalAccess = async () => {
      try {
        console.log('🔍 Checking member portal access...');
        console.log('📍 Full URL will be:', axiosInstance.defaults.baseURL + '/member-portal/my-profile/');

        const response = await axiosInstance.get("/member-portal/my-profile/");
        console.log('✅ Member profile response:', response.data);
        setMemberProfile(response.data);
      } catch (error) {
        console.log('❌ Member profile error:', error.response?.status, error.response?.data);
        console.log('🌐 Error URL:', error.config?.url);
        setMemberProfile(null);
      }
    };

    if (username) {
      checkPendingRequests();
      fetchUserProfile();
      checkMemberPortalAccess();
    }
  }, [username]);

  // Dashboard menu items
  const menuItems = [
    {
      path: "/myinfo",
      name: "MyInfo",
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708
             2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1
             1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      ),
    },
    {
      path: `/memberprofile/${username}`,
      name: "Profile",
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488
             7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1
             0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966
             8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0
             3 3 0 0 1 6 0Z"
        />
      ),
    },
    {
      path: "/member-portal",
      name: "Member Portal",
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
        />
      ),
      // Add status indicators for visual feedback
      memberStatus: memberProfile ? memberProfile.verification_status : null,
    },
    {
      path: "/chat",
      name: "Messages",
      notification: pendingCount,
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20.25 8.511c.884.284 1.5 1.128 1.5
             2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354
             0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126
             2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976
             1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155
             1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455
             48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76
             1.614-2.76 3.235v6.226c0 1.621 1.152 3.026
             2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
        />
      ),
    },
    {
      path: "/contributions",
      name: "Contribute",
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 6.75v10.5m-4.5-4.5h9"
        />
      ),
    },
    {
      path: "/referral",
      name: "Referrals",
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.5 21L3 16.5m0 0L7.5 12M3
             16.5h13.5m0-13.5L21 7.5m0 0L16.5
             12M21 7.5H7.5"
        />
      ),
    },
    {
      path: "/partner-discounts",
      name: "Partners",
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20.59 13.41l-7.17 7.17a2 2 0 0
             1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0
             1 0 2.82z"
        />
      ),
    },
  ];

  return (
    <div className="myiq-container">
      <div className="background-animation" />
      <div className="dashboard-content">
        {pendingCount > 0 && (
          <Link to="/chat?tab=clubs" className="myiq-pending-banner">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
              <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            <span>A club has requested to connect with you — <strong>review it now</strong></span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </Link>
        )}
        <div className="dashboard-links">
          {menuItems.map((item, index) => (
            <Link
              to={item.path}
              className={`dashboard-card ${item.memberStatus ? `member-${item.memberStatus}` : ''}`}
              key={index}
            >
              <div className="card-content">
                <div className="card-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                  >
                    {item.icon}
                  </svg>
                  {item.notification > 0 && (
                    <span className="notification-icon">
                      {item.notification}
                    </span>
                  )}
                  {item.memberStatus && (
                    <span className={`member-status-dot ${item.memberStatus}`} />
                  )}
                </div>
                <div className="card-text">
                  <span className="card-title">{item.name}</span>
                  {item.description && (
                    <span className="card-description">{item.description}</span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MyIQ;